import React from "react";
// import smiley from "assets/smily.png";
import { withPage } from "hoc/WithPages";

const ContactUs = () => (
	<div>
		<h1 className="text-4xl font-bold mb-4">
			Contact<span className="text-primary">.</span>
		</h1>
		<div className="mb-48">
			<p>Contact Us page placeholder</p>
		</div>
	</div>
);

export default withPage(ContactUs);
